module.exports = __webpack_public_path__ + "img/icon-speaker.9bf3c810.svg";